import { PayloadAction } from '@reduxjs/toolkit';

import { Draft, DraftState } from '../slice';

const setDraftsReducer = (state: DraftState, action: PayloadAction<Draft[]>) => {
  state.drafts = action.payload;
};

export default setDraftsReducer;
